import React from 'react';
import { Stepper, Step, StepLabel, Paper } from '@mui/material';

interface BulkUpdateStepperProps {
  steps: string[];
  activeStep: number;
}

const BulkUpdateStepper: React.FC<BulkUpdateStepperProps> = ({ steps, activeStep }) => (
  <Paper sx={{ p: 3, mb: 3 }}>
    <Stepper activeStep={activeStep} alternativeLabel>
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  </Paper>
);

export default BulkUpdateStepper; 